import { SetAdviceStateWhenClickedFromAllAdvicePageAction } from '../../../store/actions';
import { Component, HostBinding, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AppState } from '@appStates';
import { LocalizationService, ScreenDetectedService, SeoService } from '@core/services';
import { IAllAdviceList } from '@interfaces';
import { select, Store } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { RestUrlService, TypeUrl } from 'src/app/core/services/api.services/settings/rest-url.service';
import { selectAllAdviceDayTips, selectCurrentAdvicesPage } from 'src/app/store/selectors/start.page.selectors';
import { AdvicesApiService } from '../../../core/services/api.services/advices-api.service';

@Component({
  selector: 'bz-all-advice',
  templateUrl: './all-advice.component.html',
  styleUrls: ['./all-advice.component.sass']
})
export class AllAdviceComponent implements OnInit, OnDestroy {
  @HostBinding('class.scrollbar') public addScrollbar = false;

  public inputSearch = new UntypedFormControl('', [Validators.maxLength(50)]);
  public images: string;
  public adviceDayList: Observable<IAllAdviceList>;

  private currentPage: number;
  private currentSearch: string;
  private componentDestroyer = new Subject();

  constructor(
    private readonly advicesApiService: AdvicesApiService,
    private readonly locale: LocalizationService,
    private readonly store: Store<AppState>,
    private readonly restUrlService: RestUrlService,
    private readonly seo: SeoService,
    private readonly router: Router,
    private readonly screenDetectedService: ScreenDetectedService
  ) {
    this.images = this.restUrlService.getUrl(TypeUrl.img) + '/188-188/';
    this.seo.setStaticTitle('page.tips.title');
    this.seo.setStaticDescription('page.tips.description');
  }

  ngOnInit(): void {
    if (!this.screenDetectedService.isDesktop()) {
      this.addScrollbar = true;
      this.store.dispatch(SetAdviceStateWhenClickedFromAllAdvicePageAction({ state: null }));
    }

    this.store.pipe(
      select(selectCurrentAdvicesPage),
      takeUntil(this.componentDestroyer))
      .subscribe((pageNum: number) => {
        if (pageNum !== null) {
          this.currentPage = pageNum;
          this.advicesApiService.getAllAdvicesWithPagesNum(pageNum);
        }
      });

    this.adviceDayList = this.store.pipe(select(selectAllAdviceDayTips));
  }

  public toAdviceTip(clickedName: string): void {
    this.router.navigate(this.locale.getReturnParamsLang(['tips', clickedName]));
  }

  public search(): void {
    this.inputSearch.valueChanges.pipe(
      distinctUntilChanged(),
      debounceTime(350),
      takeUntil(this.componentDestroyer),
    ).subscribe((data: string) => {
      if (data === this.currentSearch) { return; }
      this.currentSearch = data;
      if (data !== null && data.length > 2) { this.advicesApiService.getSearchAdviceDayTips(this.currentPage, data); }
      else { this.advicesApiService.getAllAdvicesWithPagesNum(this.currentPage); }
    });
  }


  ngOnDestroy(): void {
    this.componentDestroyer.next(null);
    this.componentDestroyer.complete();
  }

}
